import type {
  CheckExistingResponse,
  PeopleApiGetPeopleRequest,
  Person,
  UpdatePersonDto,
} from '@b-stock/account-api-client'
import type { PeopleApiCheckExistingPersonRequest } from '@b-stock/account-api-client/src/api'

import appConfig from '@config/config'
import { get, patch, post } from '@helpers/xhr'

const { api } = appConfig

export default {
  async fetchPerson(id: string) {
    const { data } = await get<Person>(api.people.id.default, null, {
      entities: { id },
    })

    return data
  },

  async updatePerson({
    id,
    data: payload,
  }: {
    id: string
    data: UpdatePersonDto
  }) {
    const { data } = await patch<Person>(api.people.id.default, payload, {
      entities: { id },
    })
    return data
  },

  async fetchPersons(payload: PeopleApiGetPeopleRequest) {
    const { data } = await get(api.people.default, payload)
    return data
  },

  async checkExistingPersons(payload: PeopleApiCheckExistingPersonRequest) {
    // `Partial<>` for the same reason as `checkUserExists` in ./signUp: this
    // endpoint returns a (mostly) empty object when the person doesn't exist,
    // including omitting `identityProviderType`, which the generated type marks
    // required.
    const { data } = await get<Partial<CheckExistingResponse>>(
      api.people.checkExisting,
      payload
    )
    return data
  },

  async resendValidationEmail({ id }: { id: string }): Promise<void> {
    await post(api.people.id.resendValidationEmail, {}, { entities: { id } })
  },

  async verifyEmail({
    id,
    verificationCode,
  }: {
    id: string
    verificationCode: string
  }): Promise<void> {
    await post(
      api.people.id.verifyEmail,
      { verificationCode },
      { entities: { id } }
    )
  },
}
